// Sample inventory data for the car dealership
export const sampleInventory = [
  {
    id: 1,
    make: 'Toyota',
    model: 'Camry',
    year: 2025,
    price: 28999,
    mileage: 12000,
    vin: '1HGBH41JXMN109186',
    stockNumber: 'TC2025001',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    condition: 'New',
    exteriorColor: 'Midnight Black',
    interiorColor: 'Ash Gray',
    drivetrain: 'FWD',
    engine: '2.5L 4-Cylinder',
    mpg: '32 city / 41 highway',
    doors: 4,
    seating: 5,
    images: [
      'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=800&h=600&fit=crop'
    ],
    features: [
      'Bluetooth Connectivity',
      'Backup Camera',
      'Heated Front Seats',
      'Apple CarPlay',
      'Android Auto',
      'Lane Keep Assist',
      'Adaptive Cruise Control',
      'Blind Spot Monitoring',
      'LED Headlights',
      'Keyless Entry',
      'Push Button Start',
      'Dual-Zone Climate Control'
    ],
    description: 'This pristine 2025 Toyota Camry offers the perfect blend of style, comfort, and reliability. With advanced safety features and modern technology, this vehicle is perfect for daily commuting and long road trips.',
    warranty: '3 years / 36,000 miles',
    history: 'Clean CarFax report available',
    cityMPG: 32,
    highwayMPG: 41,
    combinedMPG: 36,
  },
  {
    id: 2,
    make: 'Honda',
    model: 'Accord',
    year: 2023,
    price: 25999,
    mileage: 25000,
    vin: '1HGBH41JXMN109187',
    stockNumber: 'HA2023001',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    condition: 'Used',
    exteriorColor: 'Silver Metallic',
    interiorColor: 'Black Leather',
    drivetrain: 'FWD',
    engine: '1.5L Turbo 4-Cylinder',
    mpg: '30 city / 38 highway',
    doors: 4,
    seating: 5,
    images: [
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=800&h=600&fit=crop'
    ],
    features: [
      'Apple CarPlay',
      'Lane Keep Assist',
      'Sunroof',
      'Heated Seats',
      'Bluetooth',
      'Backup Camera',
      'Cruise Control',
      'Power Seats',
      'Alloy Wheels',
      'Fog Lights',
      'Remote Start',
      'Leather Interior'
    ],
    description: 'Excellent condition 2023 Honda Accord with low mileage and premium features. This reliable sedan offers great fuel economy and a comfortable ride.',
    warranty: '1 years / 24,000 miles remaining',
    history: 'One owner, clean history, non-smoker',
    cityMPG: 30,
    highwayMPG: 38,
    combinedMPG: 33,
  },
  {
    id: 3,
    make: 'Ford',
    model: 'F-150',
    year: 2025,
    price: 45999,
    mileage: 5000,
    vin: '1FTFW1E50NFC12345',
    stockNumber: 'FF2025001',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    condition: 'New',
    exteriorColor: 'Oxford White',
    interiorColor: 'Black Leather',
    drivetrain: '4WD',
    engine: '3.5L V6 EcoBoost',
    mpg: '20 city / 24 highway',
    doors: 4,
    seating: 5,
    images: [
      'https://images.unsplash.com/photo-1594736797933-d0acce3d4633?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop'
    ],
    features: [
      '4WD',
      'Towing Package (11,500 lbs)',
      'Leather Seats',
      'Navigation System',
      'SYNC 4 Infotainment',
      'Adaptive Cruise Control',
      'Blind Spot Monitoring',
      'LED Headlights',
      'Spray-In Bed Liner',
      'Running Boards',
      'Remote Start',
      'Heated/Cooled Seats'
    ],
    description: 'Brand new 2025 Ford F-150 with the powerful EcoBoost engine and 4WD capability. Perfect for work or play with exceptional towing capacity.',
    warranty: '3 years / 36,000 miles bumper-to-bumper',
    history: 'Brand new vehicle - 0 previous owners',
    cityMPG: 20,
    highwayMPG: 24,
    combinedMPG: 22,
  },
  {
    id: 4,
    make: 'BMW',
    model: '3 Series',
    year: 2023,
    price: 42999,
    mileage: 18000,
    vin: 'WBA5A5C50JA123456',
    stockNumber: 'BMW2023001',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    condition: 'Used',
    exteriorColor: 'Mineral Gray Metallic',
    interiorColor: 'Black SensaTec',
    drivetrain: 'RWD',
    engine: '2.0L Turbo 4-Cylinder',
    mpg: '26 city / 36 highway',
    doors: 4,
    seating: 5,
    images: [
      'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop'
    ],
    features: [
      'Premium Sound System',
      'Navigation System',
      'Sport Package',
      'Sunroof',
      'Leather Seats',
      'Heated Seats',
      'Bluetooth',
      'Backup Camera',
      'Xenon Headlights',
      'Alloy Wheels',
      'Power Seats',
      'Sport Steering Wheel'
    ],
    description: 'Sophisticated 2023 BMW 3 Series with sport package and premium features. This luxury sedan delivers exceptional performance and comfort.',
    warranty: '1 year / 12,000 miles remaining BMW warranty',
    history: 'Single owner, garage kept, non-smoker',
    cityMPG: 26,
    highwayMPG: 36,
    combinedMPG: 30,
  },
  {
    id: 5,
    make: 'Tesla',
    model: 'Model 3',
    year: 2025,
    price: 39999,
    mileage: 8000,
    vin: '5YJ3E1EA1KF123456',
    stockNumber: 'TM2025001',
    fuelType: 'Electric',
    transmission: 'Single Speed',
    condition: 'Used',
    exteriorColor: 'Pearl White Multi-Coat',
    interiorColor: 'Black Premium Interior',
    drivetrain: 'RWD',
    engine: 'Electric Motor',
    mpg: '134 city / 126 highway MPGe',
    doors: 4,
    seating: 5,
    images: [
      'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop'
    ],
    features: [
      'Autopilot',
      'Supercharging Capable',
      'Glass Roof',
      'Premium Connectivity',
      '15" Touchscreen',
      'Over-the-Air Updates',
      'Mobile Connector',
      'Premium Audio',
      'Heated Seats',
      'HEPA Air Filter',
      'Sentry Mode',
      'Dog Mode'
    ],
    description: 'Nearly new 2025 Tesla Model 3 with low mileage and all premium features. This electric sedan offers cutting-edge technology and zero emissions.',
    warranty: '3 years / 28,000 miles remaining basic warranty',
    history: 'Single owner, always garaged, excellent condition',
    cityMPG: 134,
    highwayMPG: 126,
    combinedMPG: 130,
  },
  {
    id: 6,
    make: 'Chevrolet',
    model: 'Silverado',
    year: 2023,
    price: 38999,
    mileage: 22000,
    vin: '1GCPWBEH5NZ123456',
    stockNumber: 'CS2023001',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    condition: 'Used',
    exteriorColor: 'Summit White',
    interiorColor: 'Jet Black Cloth',
    drivetrain: '4WD',
    engine: '5.3L V8',
    mpg: '16 city / 22 highway',
    doors: 4,
    seating: 6,
    images: [
      'https://images.unsplash.com/photo-1594736797933-d0acce3d4633?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop'
    ],
    features: [
      'Crew Cab',
      'Spray-In Bed Liner',
      'Tow Package (9,400 lbs)',
      'Bluetooth',
      'Backup Camera',
      '4WD',
      'Remote Start',
      'Power Windows',
      'Power Locks',
      'Cruise Control',
      'Air Conditioning',
      'USB Ports'
    ],
    description: 'Reliable 2023 Chevrolet Silverado 1500 Crew Cab with 4WD and towing package. Perfect work truck with comfortable seating and proven V8 power.',
    warranty: '1 years / 14,000 miles remaining powertrain warranty',
    history: 'Fleet vehicle, regular maintenance, good condition',
    cityMPG: 16,
    highwayMPG: 22,
    combinedMPG: 19,
  }
];

export default sampleInventory;